<div class="valg-input-group__wrapper" [class.mb-0]="compact" [class.secondary]="secondary" [id]="id">
  <ng-container *ngIf="inputElement || dropdownInput || comboBoxInput || inputFile || multiInputFile">
    <ng-container *ngTemplateOutlet="label"></ng-container>
    <ng-container *ngTemplateOutlet="hint"></ng-container>
    <ng-container *ngTemplateOutlet="feedback"></ng-container>
    <div [class.valg-input__wrapper]="inputElement" *ngIf="inputElement || datepicker">
      <ng-container *ngTemplateOutlet="input"></ng-container>
      <ng-container *ngTemplateOutlet="inputSearch"></ng-container>
      <ng-container *ngTemplateOutlet="inputTime"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="inputFileTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="multiInputFileTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="dropdown"></ng-container>
  </ng-container>
  <ng-container *ngIf="radio || checkbox">
    <fieldset>
      <legend>{{ legend | translate }} </legend>
      <ng-container *ngTemplateOutlet="feedback"></ng-container>
      <ng-container *ngTemplateOutlet="input"></ng-container>
    </fieldset>
  </ng-container>
</div>

<ng-template #label>
  <ng-content select="[valgLabel]"></ng-content>
</ng-template>

<ng-template #hint>
  <ng-content select="[valgFormHint]"></ng-content>
</ng-template>

<ng-template #input>
  <ng-content
          select="input[valgInput], textarea[valgInput], valg-radio, valg-checkbox-group, input[valgPhoneNumberInput], input[valgPostalCodeInput], valg-datepicker, valg-form-password"
  ></ng-content>
</ng-template>

<ng-template #inputFileTemplate>
  <ng-content
          select="valg-input-file"
  ></ng-content>
</ng-template>

<ng-template #multiInputFileTemplate>
  <ng-content
          select="valg-multi-input-file"
  ></ng-content>
</ng-template>

<ng-template #dropdown>
  <ng-content
          select="valg-input-dropdown, valg-combo-box"
  ></ng-content>
</ng-template>

<ng-template #feedback>
  <div class="valg-input-group__error" [class.sr-only]="hideFeedback" *ngIf="errorMessage" [attr.role]="alertMessage ? 'alert': null" [id]="feedbackId">
    {{ errorMessage | translate: getErrorParam(errorMessage) }}
  </div>
</ng-template>

<ng-template #inputSearch>
  <div class="valg-input-search" #searchGroup>
    <div class="input-search-with-clear-button" *ngIf="enableClear">
      <ng-content select="input[valgInputSearch], input[valgCprSearchInput], input[valgAddressSearchInput]"></ng-content>
      <button (click)="clearSearch()" *ngIf="enableClear && isClearAvailable && searchGroup.children.length > 0" type="button" valgButton aria-label="clear search" class="clear-button">
        <mat-icon class="clear-icon" [svgIcon]="SvgIcon.Close"></mat-icon>
      </button>
    </div>
    <button (click)="performSearch()" *ngIf="searchGroup.children.length > 0" #searchButton valgButton class="search-button">
      <mat-icon [svgIcon]="SvgIcon.Search"></mat-icon>
      {{ 'buttons.search' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #inputTime>
  <div class="valg-input-time" #timeGroup>
    <ng-content select="input[valgTimeInput]"></ng-content>
  </div>
</ng-template>
